import './index.scss';
import { FC, useEffect, useMemo, useState } from 'react';
import {
	ITrackingEvent,
	ProductVM,
	TrackingEmailVariables,
	TrackingEventStatus,
	TrackingEventType
} from '../../common/view-model';
import { ProductOverviewComponent } from './overview/ProductOverviewComponent';
import { Product, GetProductReviewsData, GetProductReviewsVars } from '../../common/model';
// import { Product } from '../../common/model';
// import ProductAccordionComponent from './accordion/ProductAccordionComponent';
import { AboutBrandComponent } from './aboutBrand/AboutBrandComponent';
// import { ProductCertificationsComponent } from './certifications/ProductCertificationsComponent';
import { ScreenType } from '../../common/view-model';
import { validateAllImagesHaveError } from '../../helpers/validateAllImagesHaveError';
import { ingredientListMapper } from '../../helpers/ingredientListMapper';
import { useSearchParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/AppReducer';
import { handleTracking } from '../../helpers/handelTracking';
import { getUrlTrackingParamsObject } from '../../helpers/getUrlParamsObject';
import { GET_REVIEWS_AND_RATINGS } from '../../graphql/queries/reviewsAndRatings';
import { useLazyQuery } from '@apollo/client';
import { ReviewsAndRatingsComponent } from './ReviewsAndRatings/ReviewsAndRatings';
import { ContactInformationComponent } from './accordion/contactInformation/ContactInformationComponent';
import { DescriptionComponent } from './accordion/description/DescriptionComponent';
import { DistributionComponent } from './accordion/distribution/DistributionComponent';
import SpinsMetricsComponent from './accordion/spinMetrics/SpinsMetricsComponent';
import { SubstainabiltyComponent } from './accordion/substainability/SubstainabiltyComponent';
import { validateAllMetricsUnavailable } from '../../helpers/validateAllMetricsUnavailable';

interface IProductDetailComponentProps {
	product?: Product;
	deviceScreen?: ScreenType;
	registerUserClickEvent: (event: string) => void;
}

export const ProductDetailComponent: FC<IProductDetailComponentProps> = ({
	product,
	deviceScreen,
	registerUserClickEvent
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const userState = useSelector((state: RootState) => state.appState.userState?.user);

	const mapper = (product?: Product): ProductVM | undefined => {
		if (product) {
			return {
				...product,
				filtered: false,
				hasNavigate: true,
				allImagesHaveError: validateAllImagesHaveError(product.images as any[]),
				ingredientsList: ingredientListMapper(product.ingredientsList)
			};
		}
	};
	const [currentProduct, setCurrentProduct] = useState<ProductVM | undefined>(mapper(product));

	useEffect(() => {
		let searchTrackingObject = getUrlTrackingParamsObject(
			TrackingEmailVariables.UTM_TRACKING,
			searchParams
		);
		if (searchTrackingObject.trackingParam && searchTrackingObject.trackingParam === 'true') {
			const trackingEvent: ITrackingEvent = {
				transactionId: uuidv4(),
				status: TrackingEventStatus.SUCCESS,
				type: TrackingEventType.EMAIL_TRACKING_PRODUCT,
				timeStamp: new Date().toISOString(),
				entityId: product?.id!,
				eventPayload: {
					id: product?.id!,
					name: product?.name!,
					type: product?.taxonomy[0].name!,
					url: window.location.href,
					tags: [],
					metadata: {
						product_brand_name: product!.brand.name,
						user_type: userState?.user_type,
						enviroment: import.meta.env.VITE_ENV_NAME
					}
				}
			};
			handleTracking(trackingEvent);
			delete searchTrackingObject.object[TrackingEmailVariables.UTM_TRACKING];
			setSearchParams(searchTrackingObject.object);
		}
	}, []);

	useEffect(() => {
		setCurrentProduct(mapper(product));
	}, [product]);

	const allMetricsUnavailable = validateAllMetricsUnavailable(product);

	const tabs = [
		{
			key: 'description',
			label: 'Description',
			component: <DescriptionComponent product={product} />
		},
		{
			key: 'spins',
			label: 'SPINS Metrics',
			component: (
				<SpinsMetricsComponent product={product} allMetricsUnavailable={allMetricsUnavailable} />
			)
		},
		{
			key: 'distribution',
			label: 'Distribution',
			component: <DistributionComponent product={product} />
		},
		{
			key: 'substainability',
			label: 'Sustainability',
			component: <SubstainabiltyComponent product={product} />
		}
	];

	const [activeTab, setActiveTab] = useState('description');

	const [getReviews, { data: reviewsData }] = useLazyQuery<
		GetProductReviewsData,
		GetProductReviewsVars
	>(GET_REVIEWS_AND_RATINGS, {
		fetchPolicy: 'cache-first'
	});

	useEffect(() => {
		if (product?.id) {
			getReviews({ variables: { productId: product?.id } });
		}
	}, [product?.id, getReviews]);

	const { reviewCount, averageRating } = useMemo(() => {
		const reviews = reviewsData?.getProductReviews ?? [];
		const count = reviews.length;

		const total = reviews.reduce((sum, r) => {
			const rating = Number.parseFloat((r as any)?.starRatings);

			return sum + (Number.isFinite(rating) ? rating : 0);
		}, 0);

		return {
			reviewCount: count,
			averageRating: count ? total / count : 0
		};
	}, [reviewsData]);
	return (
		<div className='product-detail'>
			{product && (
				<div className='col'>
					<div data-testid='product-overview-component'>
						<ProductOverviewComponent
							product={currentProduct}
							deviceScreen={deviceScreen}
							registerUserClickEvent={registerUserClickEvent}
							reviewCount={reviewCount}
							averageRating={averageRating}
						/>
					</div>
					{/* {currentProduct?.certifications && currentProduct.certifications.length > 0 && (
						<div>
							<ProductCertificationsComponent
								product={currentProduct}
								deviceScreen={deviceScreen}
								registerUserClickEvent={registerUserClickEvent}
							/>
						</div>
					)} */}
					{/* <div>
						<ProductAccordionComponent product={currentProduct} />
					</div> */}
					{(deviceScreen === ScreenType.TABLET || deviceScreen === ScreenType.SMALL_DESKTOP) && (
						<div className='tabs-wrapper'>
							{/* TAB HEADERS */}
							<div className='tabs-header'>
								{tabs.map(tab =>
									(tab.label === 'Sustainability' && product?.howGoodScore?.score === null) ||
									(tab.label === 'SPINS Metrics' &&
										product?.spinsMetrics?.dollars === null) ? null : (
										<div key={tab.key} className='tab-item'>
											<button
												className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
												onClick={() => setActiveTab(tab.key)}
											>
												{tab.label === 'SPINS Metrics' ? (
													<>
														SPINS<sup>TM</sup> Metrics
													</>
												) : (
													tab.label
												)}
											</button>

											{/* Small underline under active tab */}
											{activeTab === tab.key && <div className='active-underline'></div>}
										</div>
									)
								)}
							</div>

							{/* Big grey underline */}
							<div className='big-underline'></div>

							{/* CONTENT COMPONENT */}
							<div className='tab-content'>{tabs.find(t => t.key === activeTab)?.component}</div>
						</div>
					)}
					{(reviewsData?.getProductReviews?.length ?? 0) > 0 && (
						<div id='reviews-section'>
							<ReviewsAndRatingsComponent reviews={reviewsData?.getProductReviews ?? []} />
						</div>
					)}
					<div>
						<ContactInformationComponent
							brokers={product?.brand?.brokers}
							contact={{
								name: product?.brand.contact_name,
								email: product?.brand.contact_email,
								phone: product?.brand.contact_phone
							}}
							productRep={product?.brand.prod_rep}
						/>
					</div>
					<div>
						<AboutBrandComponent
							product={currentProduct}
							registerUserClickEvent={registerUserClickEvent}
						/>
					</div>
					<div className='disclaimer'>
						Disclaimer: Product data accurate as of {product.month} {product.year}. Data updated
						annually.
					</div>
				</div>
			)}
		</div>
	);
};
